export default "__VITE_PUBLIC_ASSET__0c42f6d2__"